var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"id":"statsCard"}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-icon',{staticClass:"pe-2"},[_vm._v(" mdi-chart-line ")]),_vm._v(" Last 30 days ")],1),_c('v-card-text',[_c('line-chart',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"dataset-id-key":"label","height":160}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }